export default __webpack_public_path__ + "7a5c1dabe8d5c4c907d4be2100328970.svg";